import React from "react";
import { Image, Stack, Text ,SimpleGrid,Box,UnorderedList,ListItem} from '@chakra-ui/react'
export const AboutHealthcare=()=>{
    // AboutHealthcare

    return(
        <>
         <Stack  textAlign="left" color="#4f585e"  marginLeft="8em" marginRight="8em"
          marginTop="3em"
          marginBottom="3em"
          >
            <Stack  >
                <Text  marginBottom="-0.5em"lineHeight='110%' fontWeight="bold" >Shop Safely And Worry-Free On PharmEasy</Text>
            </Stack>
            <Stack >
                <Text marginBottom="-0.5em">PharmEasy is a renowned name in the online shopping of Over The Counter or healthcare products and other daily essentials. Ordering online on PharmEasy is convenient, fast and hassle-free; you can avoid the annoyance of queuing up at your local pharmacy and also avail of huge discounts of up to 80% OFF. Purchasing the healthcare requirements such as medical devices and nutritional supplements that you need will no longer burn a hole in your pocket. At PharmEasy, you are sure to find everything that you need because we have products across all healthcare categories.</Text>
            </Stack>
            <Stack marginBottom="0em">
                <Text marginBottom="-0.5em"  fontWeight="bold">Why choose PharmEasy?</Text>
                <UnorderedList>
                <ListItem color={"#319795"}><Text color={"#4f585e"}>8400+ Brands</Text> </ListItem>
                <ListItem  color={"#319795"}><Text color={"#4f585e"}>35K products in our stock</Text> </ListItem>
                <ListItem  color={"#319795"}><Text color={"#4f585e"}>Delivery to 22000+ pin codes</Text> </ListItem>
                <ListItem  color={"#319795"}><Text color={"#4f585e"}>Delivered to 50 lakh+ families</Text> </ListItem>
                <ListItem color={"#319795"}><Text  marginBottom="-0.5em" color={"#4f585e"}>Over 2M customers served</Text></ListItem>
                </UnorderedList>
            </Stack>
            <Stack>
                <Text marginBottom="-0.5em"    fontWeight="bold">Our most popular categories:</Text>
                <Text marginBottom="-0.5em"  >We have a range of categories and products, some which are:</Text>
            </Stack>
            <Stack>
                <Text marginBottom="-0.5em"  fontWeight="bold">Devices</Text>
                <Text marginBottom="-0.5em" >With the pandemic upending our lives, we have all realized that there are some medical devices that we need to keep in our homes such as Oximeter, Thermometer, Inhaler, Blood pressure monitor, Glucometer.</Text>
            </Stack>
            <Stack>
                <Text marginBottom="-0.5em"  fontWeight="bold">Personal care</Text>
                <Text marginBottom="-0.5em" >Personal care products can include a wide range of products such as Bath products, , Skincare essentials, Razor blades, Toothpaste and toothbrush, Wet wipes, Lip balm, Face masks, Hand sanitizer, etc.</Text>
            </Stack>
            <Stack>
                <Text marginBottom="-0.5em"  fontWeight="bold">
                Nutrition and fitness supplements
                </Text>
                <Text marginBottom="-0.5em" >
                To give your health a helping hand, you can order a wide variety of health supplements including Health drinks, Nutritional powder, Nutrition tablets/capsules.
                </Text>
            </Stack>
            <Stack>
                <Text marginBottom="-0.5em"  fontWeight="bold">
                Ayurvedic care
                </Text>
                <Text marginBottom="-0.5em" >
                Place your trust in the goodness of natural and organic ayurvedic products for an all-around healthy mind and body. There’s plenty to choose from such as Aloe vera juice, Moringa capsules, Garlic capsules.
                </Text>
            </Stack>
            <Stack>
                <Text marginBottom="-0.5em"  fontWeight="bold">
                Home care
                </Text>
                <Text marginBottom="-0.5em" >
                Home care products are things you need every day such as disinfectant spray, phenyl, dishwashing liquid, etc. Get them all at spectacular discounts on PharmEasy.
                </Text>
            </Stack>
            <Stack>
                <Text marginBottom="-0.5em"  fontWeight="bold">
                Baby and mom care
                </Text>
                <Text marginBottom="-0.5em" >
                PharmEasy also has an impressive range of baby and mom care products including Diapers, Baby bath products, Infant formula food, Mother’s health drinks, Diaper rash creams, Baby wipes.
                </Text>

            </Stack>
            <Stack>
                <Text marginBottom="-0.5em"  fontWeight="bold">
                Our top brands:</Text>
                <Text marginBottom="-0.5em" >Get products from the most famous and trusted brands including Accu-chek, Dettol, Horlicks, Baidyanath, Sebamed.</Text>
                <Text marginBottom="-0.5em"  fontWeight="bold">
                You are safe with PharmEasy:
                </Text>
                <Text marginBottom="-0.5em" >
                Given the times, we are taking all precautions to ensure that we keep everyone safe - our customers and the people we work with.
                </Text>
            </Stack>
            <Stack>
               
                <Text  marginBottom="-0.5em" fontWeight="bold">We ensure</Text>
                <UnorderedList>
                <ListItem color={"#319795"}><Text color={"#4f585e"}>Regular sanitization of our premises and warehouses</Text></ListItem>
                <ListItem color={"#319795"}><Text color={"#4f585e"}>Temperature checks of our employees and delivery partners</Text></ListItem>
                <ListItem  color={"#319795"}><Text color={"#4f585e"}>No-contact door-step delivery</Text></ListItem>
                <ListItem  color={"#319795"}><Text  marginBottom="-0.5em" color={"#4f585e"}>Sanitized packaging</Text></ListItem>
                </UnorderedList>
            </Stack>
            <Stack>
                <Text marginBottom="-0.5em"  fontWeight="bold">Youe safety is our priority</Text>
                <Text marginBottom="-0.5em" >Stay safe at home and shop at your convenience from PharmEasy. All you have to do is place your order and we will try to deliver it at the earliest.</Text>
            </Stack>
         </Stack>
        </>
    )
}